import ProfileBillWrapper from "./ProfileBillWrapper";

export default ProfileBillWrapper;
